module.exports = __webpack_public_path__ + "img/youth_literature.23131f39.svg";